module.exports = __webpack_public_path__ + "static/media/IMG_20191127_125906.1d6df0a1.jpg";